// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import dayjs from 'dayjs'
import axios from 'axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Print from './utils/print';
import FilePreview from '@/components/FilePreview.vue';

import i18n from './lang' // Internationalization
import './icons' // icon
import './permission' // permission control
import mixin from './utils/mixin'
import '@/styles/index.scss' // global css
import '@/directive/roleDirective.js'
import currencyInput from '@/directive/currencyInput'

Vue.use(Print);
Vue.use(ElementUI)
Vue.component('FilePreview', FilePreview)
Vue.mixin(mixin)

Vue.directive('currency', currencyInput)

Vue.prototype.$axios= axios
Vue.config.productionTip = false
Vue.prototype.$dayjs = dayjs

Vue.prototype.$message.success = function(text) {
  Vue.prototype.$message({
    showClose: true,
    message: text,
    type: 'success',
    duration: 5000
  })
}
Vue.prototype.$message.error = function(text) {
  Vue.prototype.$message({
    showClose: true,
    message: text,
    type: 'error',
    duration: 5000
  })
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router, 
  store,
  i18n,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js